<template>
  <div class="min-h-screen relative">
    <!-- Background Image -->
      <div class="absolute inset-0 -z-10">
      <img
        src="@/assets/Order/OrderBackground.png"
        alt="Order Background"
        class="w-full h-full object-cover object-center"
      />
      <div class="absolute inset-0 bg-black/50"></div>
    </div>

    <!-- Main Content -->
    <div class="relative z-10 min-h-screen flex flex-col">

      <!-- Main Content Area -->
      <main class="flex-1 flex items-center justify-center px-4 py-20">
        <!-- Order Confirmation Popup -->
        <div class="bg-[#2A2A2A] rounded-2xl p-8 md:p-12 max-w-lg w-full shadow-2xl border border-gray-700 mt-10">
          <!-- Success Icon -->
          <div class="flex justify-center mb-6">
            <div class="relative">
              <img src="@/assets/Order/order-success.png" alt="Order Success" class="w-34 h-32" />
            </div>
          </div>

          <!-- Text Content -->
          <div class="text-center space-y-4">
            <!-- Thank You Text -->
            <h2 class="text-white text-l font-['Great_Vibes'] font-regular" style="letter-spacing: 0.3em;">
              Thank You!
            </h2>
            
            <!-- Order Placed Text -->
            <h1 class="text-[#F5BE32] text-3xl md:text-4xl font-bold">
              Your Order Has Been Placed!
            </h1>
            
            <!-- Description -->
            <p class="text-white text-lg opacity-90">
              Your order has been placed and our team is working on it!
            </p>
            
            <!-- Delivery Time -->
            <div class="flex items-center justify-center space-x-2 text-[#F5BE32] text-lg">
              <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              <span>delivered within 45-60 minutes</span>
            </div>
          </div>
        </div>
      </main>


    </div>
  </div>
</template>

<style scoped>
/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #1F1F1F;
}

::-webkit-scrollbar-thumb {
  background: #F5BE32;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #e6ac29;
}
</style> 